var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg10":""}},[_c('Header')],1),_c('v-flex',{attrs:{"xs12":"","lg10":"","pb-12":"","px-2":"","px-lg-0":""}},[_c('router-view')],1),_c('v-flex',{attrs:{"xs12":"","pt-12":""}},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }